import { Component, EventEmitter, Input, Output, signal } from '@angular/core'
import { FormsModule } from '@angular/forms'

/**
 * Confirmación reforzada para borrados desde el dashboard (pedido explícito
 * de Angie, 2026-09-16: "así como en Supabase u otros sitios, que debas
 * copiar un código y pegarlo para que se borre, para evitar accidentes") —
 * el botón de eliminar queda deshabilitado hasta que el texto escrito
 * coincide EXACTO con el código real de la tela/producto/proveedor.
 */
@Component({
  selector: 'app-confirmar-borrado-modal',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './confirmar-borrado-modal.html',
  styleUrl: './confirmar-borrado-modal.scss',
})
export class ConfirmarBorradoModalComponent {
  @Input({ required: true }) titulo = ''
  @Input({ required: true }) mensaje = ''
  @Input({ required: true }) codigoConfirmacion!: string
  @Input({ required: true }) accion!: () => Promise<void>

  @Output() cerrar = new EventEmitter<void>()
  @Output() eliminado = new EventEmitter<void>()

  readonly texto = signal('')
  readonly eliminando = signal(false)
  readonly error = signal<string | null>(null)
  readonly copiado = signal(false)

  async copiarCodigo(): Promise<void> {
    try {
      await navigator.clipboard.writeText(this.codigoConfirmacion)
      this.copiado.set(true)
      setTimeout(() => this.copiado.set(false), 1500)
    } catch {
      // Sin permiso de portapapeles (poco común) — la persona igual puede escribirlo a mano.
    }
  }

  get coincide(): boolean {
    return this.texto().trim() === this.codigoConfirmacion
  }

  async confirmar(): Promise<void> {
    if (!this.coincide || this.eliminando()) return
    this.error.set(null)
    this.eliminando.set(true)
    try {
      await this.accion()
      this.eliminado.emit()
    } catch (err) {
      this.error.set(err instanceof Error ? err.message : 'No se pudo eliminar, intenta de nuevo.')
    } finally {
      this.eliminando.set(false)
    }
  }
}
